import { Box, Typography } from "@mui/material";

import useColors from "../../../../../../api/hooks/useColors";
import SvgToIcon from "../../../../../../icons/SvgToIcon";
import { ReactComponent as LeftArrowIcon } from "../../../../../stack/environment/icons/arrow_icons/arrow-left-currentColor-24.svg";
import { ReactComponent as RightArrowIcon } from "../../../../../stack/environment/icons/arrow_icons/arrow-right-currentColor-24.svg";

export const ArrowButton = ({ text, onClick, forward = true }) => {
  const colors = useColors();
  const items = [
    <Typography
      variant="caption"
      color={colors.button_text_inherit_enabled_text}
    >
      {text}
    </Typography>,
    <SvgToIcon
      IconLogo={forward ? RightArrowIcon : LeftArrowIcon}
      width="18px"
      style={{ color: colors.button_text_inherit_enabled_text }}
    />,
  ];
  return (
    <Box
      display="flex"
      alignItems="center"
      gap={forward ? 1 : 0.5}
      onClick={onClick}
      sx={{ cursor: "pointer" }}
    >
      {forward ? items : items.reverse()}
    </Box>
  );
};
